var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart",style:({ 'height': _vm.height })},[_c('v-chart',{ref:"chart",attrs:{"option":_vm.opts,"update-options":{ notMerge: false },"init-options":{ renderer: 'canvas' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }